/**
 * Opens a file in a new tab without triggering mobile browser popup blockers.
 * Opens a blank tab on click, then redirects it once we get the URL.
 * Falls back to opening in the same tab if a new tab cannot be created e.g popup blocked
 * or when opening from saved home-screen where new tabs aren’t supported.
 */

export const openFileFromAsyncUrl = async (fetchDownloadUrl: () => Promise<string>): Promise<void> => {
  const newWindow: Window | null = window.open('', '_blank');

  try {
    const url = await fetchDownloadUrl();

    if (!url) {
      newWindow?.close();
      throw new Error('No URL returned from fetchDownloadUrl');
    }

    if (!newWindow) {
      window.location.assign(url);
      return;
    }

    newWindow.opener = null;
    newWindow.location.href = url;
    newWindow.focus?.();
  } catch (error) {
    newWindow?.close();
    throw error;
  }
};
